<template>
  <div>
    <el-table
      ref="singleTable"
      :data="cashData"
      highlight-current-row
      style="
         {
          overflow-x: scroll;
        }
      "
    >
      <el-table-column property="date" label="Date">
        <template slot-scope="scope">
          <el-date-picker
            size="small"
            type="date"
            :picker-options="{
              disabledDate: (time) => disabledDate(time),
            }"
            placeholder="Pick a date"
            v-model="scope.row.date"
          ></el-date-picker>
        </template>
      </el-table-column>
      <el-table-column property="type" label="Type">
        <template slot-scope="scope">
          <el-select
            @change="updateCashData"
            size="small"
            v-model="scope.row.type"
            placeholder="Type"
          >
            <el-option label="Addition" value="add"> </el-option>
            <el-option label="Deduction" value="deduct"> </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column width="150" property="amount" label="Amount">
        <template slot-scope="scope">
          <el-input-number
            @change="updateCashData"
            size="small"
            :precision="2"
            :min="0"
            v-model="scope.row.amount"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column width="250" property="note" label="Note">
        <template slot-scope="scope">
          <el-input size="small" placeholder="Note" v-model="scope.row.note">
          </el-input>
        </template>
      </el-table-column>
      <el-table-column width="100" label="">
        <template slot="header" slot-scope="scope">
          <el-button size="small" type="primary" @click="addRow()"
            >Add Row</el-button
          >
        </template>
        <template slot-scope="scope">
          <el-button
            size="small"
            @click="handleDelete(scope.$index, scope.row)"
            type="danger"
            icon="el-icon-delete"
            circle
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 20px">
      <!-- <el-button plain @click="showPriceTable = false">Close</el-button> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "CFAddDeductTable",
  props: ["cashData", "updateCashData"],
  data() {
    return {
      currentRow: null,
      store: "",
      tableData: [],
    };
  },
  created() {},

  methods: {
    // updatePriceData(store) {
    //   // this.tableData = this.priceData;
    //   // this.tableData = this.tableData.filter((data) => data.store === store);
    //   console.log(this.priceData, this.tableData);
    // },
    addRow() {
      this.cashData.push({
        date: new Date(),
        type: "",
        amount: 0,
        note: "",
      });
      this.updateCashData();
      console.log(this.cashData);
    },
    disabledDate(date) {
      return date > new Date();
    },
    handleDelete(index, row) {
      this.cashData.splice(index, 1);
      this.updateCashData();
      console.log(this.cashData);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/admin/CFAddDeductTable.vue